/**
 * Converts a number of bytes to a human-readable string with appropriate unit (Bytes, KiB, MiB, etc.)
 *
 * @param bytes - The number of bytes to format. Can be a number or string that can be converted to a number
 * @param decimals - The number of decimal places to include in the result (default: 2)
 * @returns A formatted string with the appropriate unit (e.g., "1 KiB", "1.21 KiB", "0 Bytes")
 *
 * @example
 * formatBytes(1024)       // "1 KiB"
 * formatBytes('1024')     // "1 KiB"
 * formatBytes(1234)       // "1.21 KiB"
 * formatBytes(1234, 3)    // "1.205 KiB"
 * formatBytes(0)          // "0 Bytes"
 * formatBytes('0')        // "0 Bytes"
 */
export function formatBytes(bytes: number | string, decimals = 2) {
  const numBytes = Number(bytes);
  if (!numBytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  const i = Math.floor(Math.log(numBytes) / Math.log(k));

  return `${parseFloat((numBytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}
